import { Typography, Box, Grid, Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import AdminSubmittedDisplay from "../../components/Submitted/AdminSubmittedDisplay";
import moment from "moment";
import ToFrom from "../../components/ToFrom";
import AdminSearchBar from "../../components/Submitted/AdminSearchBar";
import {
  getStrictTsHours,
  getAllFilteredTimesheets,
} from "../../util/newTimeSheetHelper";
import ErrorPopUp from "../../components/Pop_ups/ErrorPopUp";
import LoadingPopUp from "../../components/Pop_ups/LoadingPopUp";
import { isObjectEmpty } from "../../util/generalHelp";
import PropTypes from "prop-types";
import { getInvoiceDocumentUrl } from "../../util/invoiceHelper";
import { fonts } from "../../util/Theme";
import TimesheetPopUp from "../../components/Pop_ups/TimesheetPopUp";
import SuccessSnackBar from "../../components/SuccessSnackBar";

/**
 * Page responsible for displaying timesheets on the admin end
 * @component
 * @category Pages
 * @subcategory Admin 
 */
function AdminSubmitted(props) {
  const [timesheets, setTimesheets] = useState([]);
  const [nameLists, setNameLists] = useState({});
  const [filteredTimesheets, setFilteredTimesheets] = useState([]);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [periodToFrom, setPeriodToFrom] = useState([
    undefined,
    undefined,
  ]);
  const [submittedToFrom, setSubmittedToFrom] = useState([
    undefined,
    undefined,
  ]);
  const [error, setError] = useState(false);
  const [currentTimeSheet, setCurrentTimeSheet] = useState({});
  const [infoObj, setInfoObj] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchObj, setSearchObj] = useState({});
  const [filterExpanded, setFilterExpanded] = useState(false);
  const [columnClick, setColumnClick] = useState(false)
  const [success, setSuccess] = useState("")
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [resources, setResources] = useState([]);
  const [projects, setProjects] = useState([]);
  const [clients, setClients] = useState([]);
  const [status, setStatus] = useState([]);
  const [resourceString, setResourceString] = useState("");
  const [projectString, setProjectString] = useState("");
  const [clientString, setClientString] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoice, setInvoice] = useState("Both");
  const [payment, setPayment] = useState([]);
  const [reset, setReset] = useState(false);
  const [allProjectStrings, setAllProjectStrings] = useState([]);
  const [allResourceStrings, setAllResourceStrings] = useState([]);
  const [allClientStrings, setAllClientStrings] = useState([]);

  useEffect(() => {
    let abortCont = new AbortController();
    if (Number.isInteger(page)){
        if (!hasLoaded) {
          setLoading(true);
        }
        getFilteredTimesheets(abortCont);
        setLoading(false);
    }
    return () => abortCont.abort();
  }, [page]);
  
  useEffect(()=>{
    let abortCont = new AbortController();
    getFilteredTimesheets(abortCont);
    return () => abortCont.abort();
  
  }, [rowsPerPage]);

  useEffect(() => {
    handleSearch();
  }, [timesheets]);

  const handleDates = (to, from, type = "period") => {
    if (to) to = moment(to).format("YYYY-MM-DD").toString();
    if (from) from = moment(from).format("YYYY-MM-DD").toString();
    if (type === "period") setPeriodToFrom([to, from]);
    else if (type === "submitted") setSubmittedToFrom([to, from]);
  };

  useEffect(() => {
    handleSearch();
    setColumnClick(!columnClick)
  }, [searchObj, periodToFrom, submittedToFrom]);

  const handleSearch = () => {
    let tempTimesheets = timesheets.filter((ts) => {
      let query = true;
      return query;
    });
    setFilteredTimesheets(tempTimesheets);
  };

  const handleTs = (ts) => {
    setLoading(true);
    getStrictTsHours(ts.timesheet.id, (resp) => {
      if (resp === undefined) {
        setError(true);
        return;
      }
      setCurrentTimeSheet(resp.full);
      let infoObj = {
        period_start_date: ts.timesheet.period_start_date,
        days_worked: ts.days,
        hours_worked: ts.hours,
        project_name: ts.project.project_name,
        submitted_date: ts.timesheet.submitted_date,
        status: ts.timesheet.status,
        envelope_ids: resp.envelope_ids,
        admin_submitted: ts.timesheet.admin_submitted,
        standard_vacation: ts.project.standard_vacation,
        notes: resp.note_text
      };
      setInfoObj(infoObj);
    });
    setLoading(false);
  };

  const handleInvoice = (filename) => {
    getInvoiceDocumentUrl(filename, (url) => {
      if (!url) {
        setError(true);
        return;
      }
      window.open(url);
    });
  };
  const handleSorting = (sortField, sortOrder) => {
    if (sortField) {
      const sorted = filteredTimesheets.sort((a, b) => {
        if (sortField === "resource") {
          return (
            a.resource.first_name
              .toString()
              .localeCompare(b.resource.first_name.toString()) *
            (sortOrder === "asc" ? 1 : -1)
          );
        }
        if (sortField === "project") {
          return (
            a.project.project_name
              .toString()
              .localeCompare(b.project.project_name.toString()) *
            (sortOrder === "asc" ? 1 : -1)
          );
        }
        if (sortField === "client") {
          return (
            a.client.short_name
              .toString()
              .localeCompare(b.client.short_name.toString()) *
            (sortOrder === "asc" ? 1 : -1)
          );
        }
        if (sortField === "period") {
          return (
            a.timesheet.period_start_date
              .toString()
              .localeCompare(b.timesheet.period_start_date.toString()) *
            (sortOrder === "asc" ? 1 : -1)
          );
        }
        if (sortField === "submitted_on") {
            let a_submitted = a.timesheet.submitted_date || -1
            let b_submitted = b.timesheet.submitted_date || -1
            moment(a_submitted).format("YYYY-MM-DD").toString();
          return (
            moment(a_submitted).format("YYYY-MM-DD").toString().localeCompare(moment(b_submitted).format("YYYY-MM-DD").toString()) *
            (sortOrder === "asc" ? 1 : -1)
          );
        }
        if (sortField === "hours") {
          return (
            a.hours.toString().localeCompare(b.hours.toString(), "en", {
              numeric: true,
            }) * (sortOrder === "asc" ? 1 : -1)
          );
        }
        if (sortField === "days") {
          return (
            a.days.toString().localeCompare(b.days.toString(), "en", {
              numeric: true,
            }) * (sortOrder === "asc" ? 1 : -1)
          );
        }
        if (sortField === "invoice_number") {

        let a_invoice = a.invoice.invoice_number || -1
        let b_invoice= b.invoice.invoice_number || -1

          return (
            a_invoice
              .toString()
              .localeCompare(b_invoice.toString(), "en", {
                numeric: true,
              }) * (sortOrder === "asc" ? 1 : -1)
          );
        }

        if (sortField === "payment_made") {
          return (
            a.invoice.payment_made
              .toString()
              .localeCompare(b.invoice.payment_made.toString()) *
            (sortOrder === "asc" ? 1 : -1)
          );
        }

        if (sortField === "consultant_paid") {
          return (
            a.invoice.consultant_paid
              .toString()
              .localeCompare(b.invoice.consultant_paid.toString()) *
            (sortOrder === "asc" ? 1 : -1)
          );
        }
        if (sortField === "status") {
          let a1, b1;
          if (a.timesheet.status === "pending") a1 = 1;
          if (b.timesheet.status === "pending") b1 = 1;
          if (a.timesheet.status === "submitted") a1 = -1;
          if (b.timesheet.status === "submitted") b1 = -1;
          return (
            a1.toString().localeCompare(b1.toString()) *
            (sortOrder === "asc" ? 1 : -1)
          );
        }
      });

      setFilteredTimesheets(sorted);
    }
  };

  const getFilteredTimesheets = (abortController) => {
    setResources(resources, resourceString);
    setClients(clients, clientString);
    setProjects(projects, projectString);
    getAllFilteredTimesheets(abortController, page, rowsPerPage, searchObj, periodToFrom, submittedToFrom, (response) => {
        if (response) {
            setTimesheets(response.timesheets);
            const nameList = {
              resources: response.resources,
              projects: response.projects,
              clients: response.clients,
            };
            setNameLists(nameList);
            setHasLoaded(true);
        } else{
            setError(true);
        }
    });
  };
  
  const handleClick = () =>{
    const abortCont = new AbortController();
    getFilteredTimesheets(abortCont);
  };
  
  return (
    <>
      <Grid
        container
        sx={{ padding: "0.5%", justifyContent: "center", alignItems: "center" }}
      >
        <LoadingPopUp open={loading || !hasLoaded} />
        <ErrorPopUp
          open={error}
          onClose={(event) => {
            event.preventDefault();
            setError(false);
          }}
        />
        <TimesheetPopUp
          open={!isObjectEmpty(currentTimeSheet)}
          onClose={() => {
            setCurrentTimeSheet({});
            setInfoObj({});
          }}
          infoObj={infoObj}
          timesheets={currentTimeSheet}
          beenSubmitted={true}
        />
        <Grid item xs={12}>
          <Typography variant="h4" align="center">
            Timesheet View
          </Typography>
        </Grid>

        <Button
          sx={{ marginBottom: "5px", marginTop: "20px" }}
          variant="outlined"
          onClick={() => {
            setFilterExpanded(!filterExpanded);
          }}
        >
          Filters
        </Button>

        {filterExpanded ? (
          <>
            <Grid
              item
              container
              xs={12}
              sx={{
                m: "1%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AdminSearchBar
                listOfProj={nameLists.projects}
                listOfResources={nameLists.resources}
                listOfClients={nameLists.clients}
                searchObj={searchObj}
                setSearchObj={setSearchObj}
                statusEnabled
                invoiceEnabled
                resources={resources}
                setResources={setResources}
                projects={projects}
                setProjects={setProjects}
                clients={clients}
                setClients={setClients}
                status={status}
                setStatus={setStatus}
                resourceString={resourceString}
                setResourceString={setResourceString}
                projectString={projectString}
                setProjectString={setProjectString}
                clientString={clientString}
                setClientString={setClientString}
                invoiceNumber={invoiceNumber}
                setInvoiceNumber={setInvoiceNumber}
                invoice={invoice}
                setInvoice={setInvoice}
                payment={payment}
                setPayment={setPayment}
                allProjectStrings={allProjectStrings}
                setAllProjectStrings={setAllProjectStrings}
                allResourceStrings={allResourceStrings}
                setAllResourceStrings={setAllResourceStrings}
                allClientStrings={allClientStrings}
                setAllClientStrings={setAllClientStrings}
              />
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <Grid
                item
                container
                sx={{
                  m: "1%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography fontSize={fonts.defaultSize}>
                  Period Date
                </Typography>
                <ToFrom
                  onChange={(to, from) => handleDates(to, from, "period")}
                  reset={reset}
                />
              </Grid>
              <Grid
                item
                container
                sx={{
                  m: "1%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography fontSize={fonts.defaultSize}>
                  Submitted Date
                </Typography>
                <ToFrom
                  onChange={(to, from) => handleDates(to, from, "submitted")}
                  reset={reset}
                />
              </Grid>
            </Box>
            <Grid
                item
                container
                sx={{
                  m: "1%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
              <Button
                variant="outlined"
                sx={{ marginBottom: "5px", marginTop: "5px" }}
                onClick={() => {
                    setPage(0);
                    setHasLoaded(false);
                    console.log('searchobj', searchObj);
                    handleClick();
                }}
              >
                Search
              </Button>
              <Button
                variant="outlined"
                sx={{ marginBottom: "5px", marginTop: "10px" }}
                onClick={() => {
                    setResources([]);
                    setResourceString("");
                    setProjects([]);
                    setProjectString("");
                    setClients([]);
                    setClientString("");
                    setStatus([]);
                    setInvoiceNumber("");
                    setPayment([]);
                    setInvoice("");
                    setPeriodToFrom([]);
                    setSubmittedToFrom([]);
                    setReset(!reset);
                }}
              >
                Clear
              </Button>
              </Grid>
          </>
        ) : (
          ""
        )}
        <Grid item container xs={12}>
          {timesheets.length > 0 ? (
            <>
            <AdminSubmittedDisplay
              timesheets={filteredTimesheets}
              handleSorting={handleSorting}
              onEnvelope={(ts) => handleTs(ts)}
              onClickInvoice={handleInvoice}
              profile={props.profile}
              onUpdate={() => getFilteredTimesheets()}
              columnClick={columnClick}
              onSuccess={setSuccess}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              hasLoaded={hasLoaded}
              setHasLoaded={setHasLoaded}
            />
            <SuccessSnackBar
              open={Boolean(success)}
              onClose={(event) => {
                event.preventDefault();
                setSuccess("");
              }}
              successmessage={success}
            />
            </>
          ) : (
            <Grid item xs={12}>
            <Typography variant="h4" align="center">
              no timesheets found
            </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
}


AdminSubmitted.propTypes = {
  /**
   * profile of currently logged in resource (object following db schema for resource)
   */
  profile: PropTypes.object.isRequired,
};

export default AdminSubmitted;
